import {createApp} from "vue";
import {createWebHistory, createRouter} from "vue-router";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from "axios";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app

import App from "@/App.vue";

// layouts

import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout

import Dashboard from "@/views/admin/Dashboard.vue";
import Settings from "@/views/admin/Settings.vue";
import Tables from "@/views/admin/Tables.vue";
import Maps from "@/views/admin/Maps.vue";

// views for Auth layout

import Login from "@/views/auth/Login.vue";
import Download from "@/views/Download.vue";

// views without layouts

import Index from "@/views/Index.vue";
import Tcgapas from "@/views/tcgapas.vue";
import neo4j from "@/views/neo4j.vue";
import tutorial from "@/views/Tutorial.vue";

const routes = [
    {
        path: "/admin",
        redirect: "/admin/dashboard",
        component: Admin,
        children: [
            {
                path: "/admin/dashboard",
                component: Dashboard,
            },
            {
                path: "/admin/settings",
                component: Settings,
            },
            {
                path: "/admin/tables",
                component: Tables,
            },
            {
                path: "/admin/maps",
                component: Maps,
            },
        ],
    },
    {
        path: "/auth",
        redirect: "/auth/login",
        component: Auth,
        children: [
            {
                path: "/auth/login",
                component: Login,
            },
        ],
    },
    // {
    //   path: "/gene_expression",
    //   component: Gene_expression,
    // },
    {
        path: "/",
        component: Index,
    },
    {
        path: "/download",
        component: Download,
    },
    {
        path: "/geia",
        component: Tcgapas,
    },
    // {
    //     path: "/3utrquan",
    //     component: tutrquan,
    // },
    // {
    //     path: "/ipaquan",
    //     component: ipaquan,
    // },
    // {
    //     path: "/3utrdiff",
    //     component: tutrdiff,
    // },
    // {
    //     path: "/ipadiff",
    //     component: ipadiff,
    // },
    {
        path: "/neo4j",
        component: neo4j,
    },
    {
        path: "/tutorial",
        name: "tutorial",
        component: tutorial,
    },
    // {
    //     path: "/ipaprotein",
    //     component: ipaprotein,
    //   },
    // {
    //     path: "/apa_rna",
    //     component: tutr_apa_rna,
    // },
    // {
    //     path: "/apa_snp",
    //     component: tutr_apa_snp,
    // },
    {path: "/:pathMatch(.*)*", redirect: "/"},
];

const router = createRouter({
    base: "/",
    history: createWebHistory("/CHBNexus/"),
    routes,
});
createApp(App).use(router).use(ElementPlus).provide('$axios', axios).mount("#app");
